import {
    WiCloud,
    WiCloudyGusts,
    WiCloudyWindy,
    WiCloudy,
    WiDayCloudyGusts,
    WiDayCloudyHigh,
    WiDayCloudyWindy,
    WiDayCloudy,
    WiDayFog,
    WiDayHail,
    WiDayHaze,
    WiDayLightWind,
    WiDayLightning,
    WiDayRainMix,
    WiDayRainWind
} from 'react-icons/wi'

import {
    ImHappy,
    ImSmile,
    ImTongue,
    ImSad,
    ImWink,
    ImGrin,
    ImCool,
    ImAngry,
    ImEvil,
    ImShocked,
    ImBaffled,
    ImConfused,
    ImNeutral,
    ImHipster,
    ImWondering,
    ImSleepy,
    ImFrustrated,
    ImCrying
} from 'react-icons/im'

export const icons = [
    {
        id: 1,
        icon: <WiCloud size={40} />,
        title: 'WiCloud'
    },
    {
        id: 2,
        icon: <WiCloudyGusts size={40} />,
        title: 'WiCloudyGusts'
    },
    {
        id: 3,
        icon: <WiCloudyWindy size={40} />,
        title: 'WiCloudyWindy'
    },
    {
        id: 4,
        icon: <WiCloudy size={40} />,
        title: 'WiCloudy'
    },
    {
        id: 5,
        icon: <WiDayCloudyGusts size={40} />,
        title: 'WiDayCloudyGusts'
    },
    {
        id: 6,
        icon: <WiDayCloudyHigh size={40} />,
        title: 'WiDayCloudyHigh'
    },
    {
        id: 7,
        icon: <WiDayCloudyWindy size={40} />,
        title: 'WiDayCloudyWindy'
    },
    {
        id: 8,
        icon: <WiDayCloudy size={40} />,
        title: 'WiDayCloudy'
    },
    {
        id: 9,
        icon: <WiCloud size={40} />,
        title: 'WiCloud'
    },
    {
        id: 10,
        icon: <WiDayFog size={40} />,
        title: 'WiDayFog'
    },
    {
        id: 11,
        icon: <WiDayHail size={40} />,
        title: 'WiDayHail'
    },
    {
        id: 12,
        icon: <WiDayLightWind size={40} />,
        title: 'WiDayLightWind'
    }
]

export const tab_icon = [
    {
        id: 1,
        icon: <ImHappy size={40} />,
        title: 'ImHappy',
        tab: 1
    },
    {
        id: 2,
        icon: <ImSmile size={40} />,
        title: 'ImSmile',
        tab: 1
    },
    {
        id: 3,
        icon: <ImTongue size={40} />,
        title: 'ImTongue',
        tab: 1
    },
    {
        id: 4,
        icon: <ImSad size={40} />,
        title: 'ImSad',
        tab: 1
    },
    {
        id: 5,
        icon: <ImWink size={40} />,
        title: 'ImWink',
        tab: 1
    },
    {
        id: 6,
        icon: <ImGrin size={40} />,
        title: 'ImGrin',
        tab: 2
    },
    {
        id: 7,
        icon: <ImCool size={40} />,
        title: 'ImCool',
        tab: 2
    },
    {
        id: 8,
        icon: <ImAngry size={40} />,
        title: 'ImAngry',
        tab: 2
    },
    {
        id: 9,
        icon: <ImEvil size={40} />,
        title: 'ImEvil',
        tab: 2
    },
    {
        id: 10,
        icon: <ImShocked size={40} />,
        title: 'ImShocked',
        tab: 2
    },
    {
        id: 11,
        icon: <ImBaffled size={40} />,
        title: 'ImBaffled',
        tab: 2
    },
    {
        id: 12,
        icon: <ImConfused size={40} />,
        title: 'ImConfused',
        tab: 2
    },
    {
        id: 13,
        icon: <ImNeutral size={40} />,
        title: 'ImNeutral',
        tab: 2
    },
    {
        id: 14,
        icon: <ImHipster size={40} />,
        title: 'ImHipster',
        tab: 3
    },
    {
        id: 15,
        icon: <ImWondering size={40} />,
        title: 'ImWondering',
        tab: 3
    },
    {
        id: 16,
        icon: <ImSleepy size={40} />,
        title: 'ImSleepy',
        tab: 3
    },
    {
        id: 17,
        icon: <ImFrustrated size={40} />,
        title: 'ImFrustrated',
        tab: 3
    },
    {
        id: 17,
        icon: <ImCrying size={40} />,
        title: 'ImCrying',
        tab: 3
    },
]